// Mock data for Osho Universal clone

export const navigation = [
  { name: 'Osho', href: '#osho', hasDropdown: true, children: [
    { name: 'Who Is Osho', to: '/who-osho' },
    { name: 'Osho Library', to: '/osho-library' }
  ] },
  { name: 'Meditate', href: '#meditate', hasDropdown: true, children: [
    { name: 'Meditation Techniques', to: '/meditations' },
    { name: 'Classes (Online or in-person)', to: '/events?type=class' },
    { name: 'Private Lessons', to: '/facilitator-and-teachers?private=1' },
    { name: 'Live Sessions', to: '/live' }
  ] },
  { name: 'Retreats & Events', to: '/events' },
  { name: 'Connect', href: '#connect', hasDropdown: true, children: [
    { name: 'Community Feed', to: '/community' },
    { name: 'Blog & News', to: '/blog' },
    { name: 'Facilitators & Teachers', to: '/facilitator-and-teachers' },
    { name: 'Explore Membership', to: '/membership' },
    { name: 'Join the Seekers Community', to: '/signup' }
  ] },
  { name: 'Find', href: '#find', hasDropdown: true, children: [
    { name: 'Classes (Online or Local)', to: '/events?type=class' },
    { name: 'Centers, Ashrams & Communes', to: '/centers' },
    { name: 'Our Temples', to: '/temples' }
  ] },
  { name: 'About', href: '#about', hasDropdown: true, children: [
    { name: 'Our Story', to: '/about-us' },
    { name: 'Founder — Sw. Prem Maitreya', to: '/about-prem' },
    { name: 'Co-Founder — Mahima Trivedi', to: '/co-founder-mahima' },
    { name: 'Inspired by Swami Anand Arun', to: '/bodhisattvaswami-arun' },
    { name: 'Contact Us', to: '/contacts' }
  ] }
];

export const quotes = [
  'When you are different the whole world is different. It is not a question of creating a different world. It is only a question of creating a different you.',
  'Life should be a continual celebration, a festival of lights the whole year round.',
  'Love is not about possession. It is about appreciation.',
  'Real love is not an escape from loneliness, real love is an overflowing aloneness.',
  'Relationship is a structure, and love is unstructured.',
  "If you are happy, it's your fault. If you are unhappy, it's your fault.",
  'The moment you accept yourself, you become beautiful.',
  'Truth is not something outside to be discovered, it is something inside to be realised.'
];

export const events = [
  {
    id: 1,
    date: '31',
    month: 'Jul',
    fullDate: '31 July, 2026',
    time: '16:00 - 14:00',
    title: 'Guru Purnima Celebration July 2026',
    price: '$50',
    image: 'https://images.unsplash.com/photo-1550096141-7263640aa48c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHw0fHxncm91cCUyMG1lZGl0YXRpb24lMjBjaXJjbGV8ZW58MHx8fHwxNzg0MTgyMjg0fDA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 2,
    date: '15',
    month: 'Aug',
    fullDate: '15 August, 2026',
    time: '09:00 - 18:00',
    title: 'Silent Meditation Retreat',
    price: '$120',
    image: 'https://images.unsplash.com/photo-1559595500-e15296bdbb48?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHw0fHxtZWRpdGF0aW9uJTIwcmV0cmVhdHxlbnwwfHx8fDE3ODQxODIyMjh8MA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 3,
    date: '02',
    month: 'Sep',
    fullDate: '02 September, 2026',
    time: '07:00 - 20:00',
    title: 'Awareness & Devotion Weekend',
    price: '$85',
    image: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxtZWRpdGF0aW9uJTIwc3Vuc2V0fGVufDB8fHx8MTc4NDE4MjIyOHww&ixlib=rb-4.1.0&q=85'
  }
];

export const stats = [
  { number: '60+', unit: 'Years', description: 'Osho, his message and his meditation techniques are helping millions across the globe.' },
  { number: 'Millions', unit: 'Worldwide', description: 'Are daily achieving peace, harmony and transformation through Osho, his meditations, and hundreds of ashrams and centers. Osho Kaivalya Dham, its associated centers and teachers are helping millions daily.' },
  { number: 'Join Us', unit: '', description: 'Become a teacher, or open an Osho Universal center at your home or within your yoga / meditation studio — and help your community, friends and family by spreading love and awareness.', link: '/teachers', linkLabel: 'Get involved' }
];

export const products = [
  {
    id: 1,
    title: 'Mystics & Miracles',
    category: ['Books'],
    price: null,
    action: 'View products',
    image: 'https://images.unsplash.com/photo-1541963463532-d68292c34b19?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxzcGlyaXR1YWwlMjBib29rJTIwbWVkaXRhdGlvbnxlbnwwfHx8fDE3ODQxODIyODR8MA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 2,
    title: 'Book of Man',
    category: ['Books', 'Health'],
    price: '$25.00',
    action: 'Add to cart',
    image: 'https://images.unsplash.com/photo-1585045319398-0a1ec17b1e3e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHw0fHx5b2dhJTIwYm9va3xlbnwwfHx8fDE3ODQxODIyOTF8MA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 3,
    title: 'Singing Bowl Set',
    category: ['Wellness'],
    price: '$65.00',
    action: 'Add to cart',
    image: 'https://images.unsplash.com/photo-1619968747226-67769140323a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwyfHxtZWRpdGF0aW9uJTIwY3J5c3RhbCUyMHNpbmdpbmclMjBib3dsfGVufDB8fHx8MTc4NDE4MjI4NHww&ixlib=rb-4.1.0&q=85'
  }
];

export const testimonials = [
  {
    id: 1,
    rating: 5,
    text: 'Every sunrise practice opened my heart a little more. I left feeling lighter, calmer, and deeply connected to myself.',
    name: 'Sofia G.',
    program: 'Roots of Stillness'
  },
  {
    id: 2,
    rating: 5,
    text: "Nature, gentle practices, and real conversations brought me back to a place of balance I'd forgotten existed.",
    name: 'Anna R.',
    program: 'Winter of Presence'
  },
  {
    id: 3,
    rating: 5,
    text: 'A profound reset. The ashram has a stillness that seeps into every cell. I return home renewed and inspired.',
    name: 'Marcus T.',
    program: 'Summer of Awakening'
  }
];

export const socialLinks = [
  { name: 'YouTube', icon: 'Youtube', href: '#' },
  { name: 'Instagram', icon: 'Instagram', href: '#' },
  { name: 'Facebook', icon: 'Facebook', href: '#' },
  { name: 'Twitter', icon: 'Twitter', href: '#' }
];

export const languages = ['English', 'Chinese (Simplified)', 'German', 'Hebrew', 'Hindi', 'Russian', 'Spanish', 'Telugu'];

export const footerLinks = {
  quickLinks: [
    { name: 'Home', href: '/' },
    { name: 'Retreats/Events', href: '/events' },
    { name: 'Shop', href: '/shop' },
    { name: 'About Osho', href: '/who-osho' },
    { name: 'Facilitators & Teachers', href: '/facilitator-and-teachers' },
    { name: 'News & Blogs', href: '/blog' },
    { name: 'My Account', href: '/dashboard' }
  ],
  aboutUs: [
    { name: 'Founder Sw. Prem Maitreya', href: '/about-prem' },
    { name: 'Inspired by Sw. Anand Arun', href: '/bodhisattvaswami-arun' },
    { name: 'About Organization', href: '/about-us' },
    { name: 'Affiliated Ashram & Centre', href: '/centers' },
    { name: 'Our Temples', href: '/temples' }
  ],
  connect: [
    { name: 'Contact Us', href: '/contacts' },
    { name: 'Donate Us', href: '/donate' },
    { name: 'Become A Member', href: '/membership' },
    { name: 'Terms & Conditions', href: '/terms-and-conditions' },
    { name: 'Privacy Policy', href: '/privacy-policy' },
    { name: 'Copyright & DMCA Policy', href: '/copyright-policy' }
  ]
};

export const heroImages = {
  hero: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxtZWRpdGF0aW9uJTIwc3Vuc2V0fGVufDB8fHx8MTc4NDE4MjIyOHww&ixlib=rb-4.1.0&q=85',
  ashram: 'https://images.unsplash.com/photo-1769638297829-cf8fbe8ad6b6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwzfHxmb3Jlc3QlMjB0ZW1wbGV8ZW58MHx8fHwxNzg0MTgyMjI4fDA&ixlib=rb-4.1.0&q=85',
  guru: 'https://images.unsplash.com/photo-1623406079247-85652018f8ac?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwyfHxzcGlyaXR1YWwlMjBndXJ1fGVufDB8fHx8MTc4NDE4MjIzNHww&ixlib=rb-4.1.0&q=85',
  nature: 'https://images.unsplash.com/photo-1524863479829-916d8e77f114?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwzfHx5b2dhJTIwbmF0dXJlfGVufDB8fHx8MTc4NDE4MjIzNHww&ixlib=rb-4.1.0&q=85',
  candles: 'https://images.unsplash.com/photo-1476900164809-ff19b8ae5968?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHxtZWRpdGF0aW9uJTIwY2FuZGxlc3xlbnwwfHx8fDE3ODQxODIyMzR8MA&ixlib=rb-4.1.0&q=85'
};
